import { AppBar, Toolbar, Typography, IconButton, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'
import RefreshIcon from '@mui/icons-material/Refresh';

function Appbar(props: any) {
	return (
		<AppBar
			sx={{ background: 'white', color: 'black' }}
		>
			<Toolbar sx={{ display: 'flex', alignItems: 'center' }}>
				<IconButton
					size="small"
					edge="start"
					color="primary"
					onClick={props.toggleDrawer}
				>
					<MenuIcon></MenuIcon>
				</IconButton>
				<Typography
					color="primary"
					variant='h6'
				>
					{props.currentTab}
				</Typography>
				{
					(props.currentTab?.indexOf("商品列表") >= 0 || props.currentTab?.indexOf("订单列表") >= 0) &&
					<Button
						onClick={props.reload}
					><RefreshIcon></RefreshIcon></Button>
				}
			</Toolbar>
		</AppBar >
	)
}

export default Appbar